import { useEffect } from "react";
import { Client } from "../../prismic1";
import SliceZone from "next-slicezone";
import Prismic from "prismic-javascript";
import { useGetStaticProps } from "next-slicezone/hooks";
import { fetchAdditionalData } from "../../utils/fetch-additional-data";
import { AdditionalDataProvider } from "../../utils/additional-data-context";
import { useLayout } from "../../utils/layout-context";
import resolver from "../../sm-resolver.js";
import { getLanguage, getExtensionLanguage } from "../../lib/getLanguage";
import BlogPostHero from "../../components/BlogPostHero";
import RecentRelatedStories from "../../components/RecentRelatedStories";
import Head from "../../components/Head";
import DiscussionEmbed from "../../components/disqus";
import Container from "@material-ui/core/Container";
import errorService from '../../services/error/error-service'
import appConstants from '../../utils/constants/vfi-constants'

const Blog = (props) => {
  const { data, blogPostHero, recentBlogs, params,uid } = props;
  const { setHeaderColor } = useLayout();

  useEffect(() => {
    if (data) setHeaderColor(data.headercolor);
  }, [data]);

  return (
    <>
      <Head data={blogPostHero.data} canonical={`/blog/${uid}`} />
      <AdditionalDataProvider value={props.additionalData}>
        <BlogPostHero blogPostHero={blogPostHero}></BlogPostHero>
        <SliceZone {...props} resolver={resolver} />
        {recentBlogs && (
          <RecentRelatedStories
            allBlogsBasedOnProjectCategory={recentBlogs}
          ></RecentRelatedStories>
        )}
        <Container maxWidth="lg" style={{paddingTop:80,paddingBottom:80}}>
          <DiscussionEmbed postId={params.uid} />
        </Container>
      </AdditionalDataProvider>
    </>
  );
};

export async function getStaticProps({
  preview = null,
  previewData = {},
  params,
  locale,
}) {
  const client = Client();
  const languageObject = getLanguage(locale);
  const language = await languageObject.prismicLanguage.toLowerCase();
  const sliceMachine = useGetStaticProps({
    client,
    params: {
      fetchLinks: [
        "project_category.icon",
        "project_category.title",
        "project.featured_image",
        "project.title",
        "project.project_category",
        "blog_post.title",
        "blog_post.featured_image",
        "blog_post.date",
        "blog_post.blog_topics",
      ],
      lang: language,
    },
    type: "blog_post",
    uid: ({ params }) => params.uid,
  });

  const { props } = await sliceMachine({ preview, previewData, params });
  const additionalData = await fetchAdditionalData(
    props.slices,
    params.uid,
    language
  );
  const blog = await client.getByUID("blog_post", params.uid, {
    lang: language,
    fetchLinks: ["blog_topic.topic_name", "project_category.title"],
  });

  const relatedBlogs = await client.query(
    [Prismic.Predicates.at("document.type", "blog_post"),Prismic.Predicates.has('my.blog_post.date')],
    {
      lang: language,
      fetchLinks: ["blog_topic.topic_name"],
      orderings: "[my.blog_post.date desc]",
    }
  );

  if (!relatedBlogs?.results || !blog?.data){
    return errorService.notFoundResponse
  }

  const recentBlogs =  relatedBlogs.results
    .filter(
      (blog) =>
        blog.data.blog_topics[0].blog_topic.uid ==
        blog.data.blog_topics[0].blog_topic.uid
    )
    .filter((blog) => blog.uid != params.uid);

  return {
    props: {
      ...props,
      additionalData,
      blogPostHero: blog,
      recentBlogs,
      params,
    },
    revalidate: appConstants.revalidateSeconds
  };
}

export async function getStaticPaths() {
  const client = Client();
  const blogPosts = await client.query(
    [Prismic.Predicates.at("document.type", "blog_post"),Prismic.Predicates.has('my.blog_post.date')],
    { pageSize: 100, lang: "*" }
  );
  const paths = blogPosts.results.map((node) => {
    const languageObject = getExtensionLanguage(node.lang);
    const language = languageObject.prismicLanguage.toLowerCase();
    return {
      params: {
        uid: node.uid,
      },
      locale: language,
    };
  });
  
  return {
    paths,
    fallback: 'blocking',
  };
}
export default Blog;
